import { useState, useEffect, useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'
import axio from 'axios'

import { projectContext, loadingContext, unfolder, openAlert, useTranslate, encrypter, downloadFileNew, onImportExcelAsync } from '../lib'
import { SelectNesting } from './common/Inputs/Select'
import { urlValue } from '../lib'
import '../styles/styles.css'
import '../styles/newProjectModal.scss'
import { customModal } from '../styles/customModal'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { Alerts } from './common/Alerts'
import Loading from './Loading'
import SearchUser from '../components/SearchUser';
import SearchIcon from '../images/search.svg';
export default function NewUserClient({ isModalOpen,  closeModal, selectedProject, sub_campaing_id, closeFunction, isCampaign = false, associateToProject = true, project_id = null }) {
  const [loadingUpload, setLoadingUpload] = useState(false)
  const [avatarPreview, setAvatarPreview] = useState(null)
  const [avatarFile, setAvatarFile] = useState(null)
  const [uploadingAvatar, setUploadingAvatar] = useState(false)
  const [loading, setLoading] = useContext(loadingContext)
  const [alertModal, setAlertModal] = useState({ title: '', visible: false })
  const [error, setError] = useState({ name: "" })
  const [showSearch, setShowSearch] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [userExist, setUserExist] = useState(null);
  const [dataForm, setDataForm] = useState(null);
  const [role, setRole] = useState(0)
  const { t } = useTranslate();
  const regionRef = useRef();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    (async () => {
      setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)
    })()

  }, []);

  function isNumeric(str) {
    return /^\d+$/.test(str);
  }
  
  // Validar que el string contenga al menos un punto
  function contienePunto(str) {
    return /\./.test(str);
  }

  
  const onError = errors => {
    if (errors.id) {
      openAlert('#alert-ac-modal', () => { setAlertModal({ title: errors.id.message, visible: true, error: true }) }, 4000,
          () => { setAlertModal({ ...alertModal, visible: false }) });
    }

    if (errors.name) {
      openAlert('#alert-ac-modal', () => { setAlertModal({ title: errors.name.message, visible: true, error: true }) }, 4000,
          () => { setAlertModal({ ...alertModal, visible: false }) });
    }
  }
  
  const onSubmitNew = async data => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    const assignToCampaign = document.querySelector("#assignToCampaign")?.checked || false;
    const assignToSubcampaign = document.querySelector("#assignToSubCampaign")?.checked  || false;

    const data2 = JSON.stringify({
      ccms_id: data.id,
      ccms_name: data.name,
      max_multichat: data.max_multichat,
      multiple: false,
      project: selectedProject.id,
      gender_avatar: data.gender_avatar,
      icims: data.wave,
    })
    const encry = encrypter(data2, 'IANestingKey')

    setLoading(true)
    axios({
      method: 'post',
      url: `${urlValue}/studio/client`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {"usuario": encry},
    })
      .then(async function (response) {
        openAlert('#alert-ac-modal', () => { setAlertModal({ title: t('alerts.accountCreated'), visible: true }) }, 4000,
          () => { setAlertModal({ ...alertModal, visible: false }) });
        if (associateToProject){
          postClientProject(response.data.client.id, true, assignToCampaign, assignToSubcampaign)
          if (avatarFile && response && response.data && response.data.client && response.data.client.id) {
            await uploadAvatar(response.data.client.ccms_name, avatarFile)
          }
        } else {
          setLoading(false)
          closeFunction(response.data.client)
          if (avatarFile && response && response.data && response.data.client && response.data.client.id) {
            await uploadAvatar(response.data.client.ccms_name, avatarFile)
          }
        }
      })
      .catch(async function (error) {
        if (error.status == 401) {
          openAlert('#alert-ac-modal', () => { setAlertModal({ title: error.response.data.message, visible: true, error: true }) }, 4000,
          () => { setAlertModal({ ...alertModal, visible: false }) });
          
          setLoading(false)
        }
        else if (error.status == 409) {
          setDataForm(data)
          setUserExist(error.response.data.data)
          setLoading(false)
          setModalUpdate(true)
          console.log("reponse.data", error.response.data.data)
        }
        else {
          if (associateToProject) {
            getIdClientByCcmsId(data.id).then(id => postClientProject(id, true, assignToCampaign, assignToSubcampaign))
          } else {
            const client = await getIdClient(data.id)
            if (client.status_code === 200) {
              closeFunction(client.data)
            }
            setLoading(false)
            // openAlert('#alert-ac-modal', () => { setAlertModal({ title: t('alerts.userExistsAddedSelection'), visible: true, error: true }) }, 4000,
            //   () => { setAlertModal({ ...alertModal, visible: false }) });
          }
        }
      })
  }

  const update_add_user = async => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    const assignToCampaign = document.querySelector("#assignToCampaign")?.checked || false;
    const assignToSubcampaign = document.querySelector("#assignToSubCampaign")?.checked  || false;
    
    setModalUpdate(false)
    setLoading(true)
    axios({
      method: 'post',
      url: `${urlValue}/studio/client/${userExist.id}/update`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        ccms_id: dataForm.id,
        ccms_name: dataForm.name,
        max_multichat: userExist.max_multichat,
        gender_avatar: dataForm.gender_avatar,
        icims: dataForm.wave,
      },
    })
      .then(function (response) {
        openAlert('#alert-ac-modal', () => { setAlertModal({ title: t('alerts.accountCreated'), visible: true }) }, 4000,
          () => { setAlertModal({ ...alertModal, visible: false }) });
          console.log(response)
        if (associateToProject){
          postClientProject(userExist.id, true, assignToCampaign, assignToSubcampaign)
        } else {
          setLoading(false)
          closeFunction({
            id: userExist.id,
            ccms_id: dataForm.id,
            ccms_name: dataForm.name,
            max_multichat: userExist.max_multichat,
            gender_avatar: dataForm.gender_avatar,
            icims: dataForm.wave,
          })
        }
      })
      .catch(function (error) {
        setLoading(false)
      })
  }

  const postClientProject = (clientId, load, assignToAllCampaignProjects = false, assignToSubcampaignProjects = false) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    
    axios({
      method: 'post',
      url: `${urlValue}/studio/client-project`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        project_id: selectedProject.id,
        client_id: clientId,
        assign_to_campaign_projects: assignToAllCampaignProjects,
        assign_to_subcampaign_projects: assignToSubcampaignProjects,
      },
    })
      .then(function (response) {
        if (load) {
          closeFunction()
          setLoading(false)
          
        }

      })
      .catch(function (error) {
        if (load) {
          // setIsModalOpen({ ...isModalOpen, new: false })
          setLoading(false)
        }
      })
  }

  const getIdClientByCcmsId = async (ccmsId, load) => {
    const client = await getIdClient(ccmsId)
    if (client?.status_code === 200) {
      if (load) setLoading(false)
      return client.data.id
    }
    if (load) setLoading(false)    
  }

  const getIdClient = async (ccmsId) => { 
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    return await axios({
      method: 'get',
      url: `${urlValue}/studio/client/bms`,
      headers: {
        id: ccmsId, //BMS del usuario a consultar
        user: id, //id del usuario studio
        'access-token': token,
      },
    })
      .then(function (response) {
        return {status_code: 200, data: response.data}
      })
      .catch(function (error) {
        console.log("error", error)
        return {status_code: 401, data: ''}
      })
  }

  const prepareExcel = async (file) => {
    const DatosExcel = await onImportExcelAsync(file, ['CCMS_ID', 'CCMS_NAME', 'GENDER', 'WAVE']);
    uploadMaxive(DatosExcel);

  }

  const uploadMaxive = async (UsersExcel) => {
    
    if (!loadingUpload && UsersExcel.length > 0 && UsersExcel.length <= 101) {

      setLoadingUpload(true)
      setTimeout(async () => {
        setLoading(true)
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
        const assignToCampaign = document.querySelector("#assignToCampaign")?.checked || false;
        const assignToSubcampaign = document.querySelector("#assignToSubCampaign")?.checked || false;
        const genders = ['female', 'male', 'other']
        let message = ''

        for (var i = 0; i < UsersExcel.length; i++) {
          const BMS = UsersExcel[i].CCMS_ID.toString().trim()
          const NTUSER = UsersExcel[i].CCMS_NAME.toString().trim()
          const gender = UsersExcel[i]?.GENDER?.toString()?.trim()?.toLowerCase() || 'male'
          let validate = true

          if (role !== 6) {
            if (!contienePunto(NTUSER) || !isNumeric(BMS) || !genders.includes(gender)){
              message = message + 'BMS: ' + BMS + ' -- NT USER: ' + NTUSER + '\n'
              validate = false
            }
          }
   
          if (validate) {
            const data = {
              ccms_id: BMS,
              ccms_name: NTUSER,
              max_multichat: 5,
              project: selectedProject.id,
              multiple: true,
              gender_avatar: gender,
              icims: UsersExcel[i]?.WAVE?.toString()?.trim() || ''
            }
            
            const encry = encrypter(data, 'IANestingKey')
            
            try {
              const rest = await axios.post(`${urlValue}/studio/client`, {"usuario": encry}, {
                headers: {
                  user: id,
                  'access-token': token,
                  'X-CSRF-Token': csrfToken
                }
              });
              if (rest.status === 200) {
                if (associateToProject) {
                  const restCp = await axios.post(`${urlValue}/studio/client-project`, {
                    project_id: selectedProject.id,
                    client_id: rest.data.client.id,
                    assign_to_campaign_projects: assignToCampaign,
                    assign_to_subcampaign_projects: assignToSubcampaign
                  },
                    { headers: { user: id, 'access-token': token } })
                }
                else {
                    closeFunction(rest.data.client)
                }
              } else {
                if (associateToProject) {
                  await getIdClientByCcmsId(BMS, false).then(id => postClientProject(id, false, assignToCampaign, assignToSubcampaign))
                }
                else {
                  const client = await getIdClient(BMS)
                  if (client.status_code === 200) {
                    closeFunction(client.data)
                  }
                }
              }
            } catch (error) {
              if (error.status !== 409) {
                if (associateToProject) {
                  await getIdClientByCcmsId(BMS, false).then(id => postClientProject(id, false, assignToCampaign, assignToSubcampaign))
                }
                else {
                  const client = await getIdClient(BMS)
                  if (client.status_code === 200) {
                    closeFunction(client.data)
                  }
                }
              }              
            }
          }

        }

        if (message !== ''){
          message = t('alerts.checkExcelTemplate')
          openAlert('#alert-ac-modal', () => { setAlertModal({ title: message, visible: true, error: true }) }, 5000,
            () => { 
              setAlertModal({ ...alertModal, visible: false }) 
              closeFunction()
              window.location.reload();
            });
          // window.alert("The following users could not be added")
        } 
        else {
          closeFunction()
          if (associateToProject) {
            window.location.reload();
          }
        }
        setLoading(false)
        setLoadingUpload(false)

        
      }, 1000)

    } else {
      openAlert('#alert-ac-modal', () => { setAlertModal({ title: t('alerts.intentExcelLimit'), visible: true, error: true }) }, 4000,
          () => { setAlertModal({ ...alertModal, visible: false }) });
    }

  } 

  const validateImageFile = (file) => {
    const allowed = ['image/jpeg', 'image/png']
    if (!allowed.includes(file.type)) return { ok: false, message: t('alerts.avatarInvalidType') }
    if (file.size > 100 * 1024) return { ok: false, message: t('alerts.avatarTooLarge') }
    return { ok: true }
  }

  const handleAvatarChange = (e) => {
    const file = e.target.files[0]
    if (!file) return
    const valid = validateImageFile(file)
    if (!valid.ok) {
      openAlert('#alert-ac-modal', () => { setAlertModal({ title: valid.message, visible: true, error: true }) }, 3000,
        () => { setAlertModal({ ...alertModal, visible: false }) });
      e.target.value = null
      return
    }

    const img = new Image()
    const url = URL.createObjectURL(file)
    img.onload = () => {
      if (img.width > 200 || img.height > 200) {
        openAlert('#alert-ac-modal', () => { setAlertModal({ title: t('alerts.avatarDimensionsExceeded'), visible: true, error: true }) }, 3000,
          () => { setAlertModal({ ...alertModal, visible: false }) });
        URL.revokeObjectURL(url)
        return
      }
      setAvatarPreview(url)
      setAvatarFile(file)
      openAlert('#alert-ac-modal', () => { setAlertModal({ title: t('alerts.avatarLoadedSuccess'), visible: true }) }, 4000,
        () => { setAlertModal({ ...alertModal, visible: false }) });
    }
    img.onerror = () => {
      openAlert('#alert-ac-modal', () => { setAlertModal({ title: t('alerts.avatarLoadError'), visible: true, error: true }) }, 3000,
        () => { setAlertModal({ ...alertModal, visible: false }) });
      URL.revokeObjectURL(url)
    }
    img.src = url
  }

  const uploadAvatar = async (clientId, file) => {
    try {
      setUploadingAvatar(true)
      const form = new FormData()
      form.append('avatar', file)
      console.log('Uploading avatar for client-id:', clientId);
      await axios.post(`${urlValue}/studio/avatar`, form, {
        headers: {
          'access-token': unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token,
          'X-CSRF-Token': unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken,
          'client-id': clientId,
          'folder': 'clients',
        },
        withCredentials: true,
      })
      openAlert('#alert-ac-modal', () => { setAlertModal({ title: t('alerts.avatarUploadSuccess'), visible: true }) }, 3000,
        () => { setAlertModal({ visible: false }) });
    } catch (e) {
      // improved error reporting to help debug 403/CSRF issues
      const serverMessage = e?.response?.data?.message || e?.response?.data || e?.message || 'Avatar upload failed'
      console.error('Avatar upload error', e)
      openAlert('#alert-ac-modal', () => { setAlertModal({ title: serverMessage, visible: true, error: true }) }, 5000,
        () => { setAlertModal({ ...alertModal, visible: false }) });
    } finally {
      setUploadingAvatar(false)
    }
  }

  return (
    <div id="container-modal" className="addUser-modal">
      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
        width: '100%'
      }}>
        <h2 style={{marginRight: 10}}>{t('menu.addUserClientForm')}</h2>
        {associateToProject && <div style={{marginLeft: 10}}>
          <img 
            src={SearchIcon} 
            style={{width: 20, height: 20, cursor: 'pointer'}} 
            onClick={() => setShowSearch(!showSearch)} 
          />
        </div>}
      </div>
      <form onSubmit={handleSubmit(onSubmitNew, onError)}>
        <div className="inputs-modal">
          <div className="input">
            <span>{t('common.bms')}:</span>
            <input
              id="ccms_id" placeholder={t('menu.specificUserId')}
              {...register('id', { required: true, 
                ...(role !== 6 ? { pattern: {value: /^\d+$/, message: t('alerts.bmsNotNumeric')} } : {})
              })}
              type="text"
            />
          </div>
          <div className="input">
            <span>{t('common.ntUser')}:</span>
            <input id="ccms_name" placeholder={t('menu.enterCCMS')} 
              {...register('name', { required: true, 
                ...(role !== 6 ? { pattern: {value: /\./, message: t('alerts.ntUserFormat')} } : {})
              })} type="text" />
          </div>
          <div className="input">
            <span>{t('common.wave')}:</span>
            <input id="wave" placeholder='Enter the specific user Wave'
              {...register('wave', { required: false })} type="text" />
          </div>
          {selectedProject.channel === 'chat' &&
          <div className="input">
            <span>{t('common.maxChat')}:</span>
            <input type='number' id="ccms_name" placeholder={t('menu.enterMaxChat')} 
              {...register('max_multichat', { required: true })} />
          </div>
          } 
          <div className="input">
            <span>{t('menu.genderAvatar')}:</span>
            <select id="gender_avatar" className='select-nesting' {...register('gender_avatar', { required: false })}
              defaultValue= "male"
              style={{
                padding: '2px 18px 2px 10px',
                backgroundColor: 'white', border: '1px solid #0087FF',
                borderRadius: 10, appearance: 'none', fontSize: 14
              }}>
              <option disabled selected>{t('common.select')}</option>
              <option value="male">{t('common.male')}</option>
              <option value="female">{t('common.female')}</option>
              <option value="other">{t('common.other')}</option>
            </select>
          </div>
        </div>
        {associateToProject && <div id="search-results-container" style={{width: '100%', marginTop: 10}}>
          <SearchUser 
            onUserSelect={(user) => {
              setValue('id', user.ccms_id);
              setValue('name', user.ccms_name);
              if (user.email) {
                setValue('email', user.email);
              }
            }}
            searchResultsContainer={document.getElementById('search-results-container')}
            showSearch={showSearch}
            setShowSearch={setShowSearch}
            filterSource={'clients'}
          />
        </div>}
        <div className="flex items-center justify-end flex-wrap w-full ml-3" style={{marginTop: 30}}>
          {associateToProject && <div className="flex items-center" style={{flexGrow: 2}}>
            <div className="flex items-center" style={{width: '300px'}}>
              <input 
                type="checkbox" 
                id="assignToCampaign"
                className="mr-2" style={{width: 20, height: 20}}
              />
              <label htmlFor="assignToCampaign" className="text-sm text-gray-700">
                {t('menu.assignUserToCampaign')}
              </label>
            </div>

            <div className="flex items-center" style={{width: '300px'}}>
              <input 
                type="checkbox" 
                id="assignToSubCampaign"
                className="mr-2" style={{width: 20, height: 20}}
              />
              <label htmlFor="assignToSubCampaign" className="text-sm text-gray-700">
                {t('menu.assignUserToSubcampaign')}
              </label>
            </div>

          </div>}

          <div className="flex flex-row items-center" style={{marginRight: 50, paddingBottom: 25}}>
            <Tooltip anchorSelect="#uploadmax-client" content={t('menu.uploadExcelUserTooltip')} place="top"
              style={{ whiteSpace: "pre-line", textAlign: "left" }}
              />
            <div id="uploadmax-client" className="upload-excel btn-excel upload-btn trans">            
              {loadingUpload ? <Loading /> : <>
                <img src="/icons/excel.svg" alt="newAns" style={{ width: 19, marginBottom: 0 }} />
                <label>{t('menu.uploadExcel')}</label>
              </>}
              <input type='file' accept='.xlsx, .xls' onChange={prepareExcel} />
            </div>

            <div style={{ marginLeft: 10, marginTop: 20}}>
              <div style={{ cursor: 'pointer' }} onClick={() => { downloadFileNew("FormatUsers.xlsx") }} className="a-download trans">
                <img src="/icons/download-icon.svg" alt="Img Template" style={{width: 15, marginRight: 5, marginBottom: 0}}/>
                {t('menu.downloadTemplate')}
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginLeft: 20, marginTop: 10, display: 'flex', alignItems: 'center', padding: 10, borderRadius: 6 }}>
          <label style={{ fontSize: 14, color: '#2E2E2E', fontWeight: 700, minWidth: 60 }}>Avatar:</label>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: 50, height: 50, border: '1px solid #ddd', borderRadius: 6, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
                {avatarPreview ? <img src={avatarPreview} alt="avatar" style={{ maxWidth: '100%', maxHeight: '100%', filter: 'none' }} /> : <img src="/avatar.png" alt="avatar" style={{ width: 36, filter: 'none' }} />}
              </div>
              <div style={{ marginLeft: 8 }}>
                <input type="file" accept="image/png,image/jpeg" onChange={handleAvatarChange} />
              </div>
            </div>
          </div>
        </div>

        <div className="buttons-modal">
          <button
            onClick={() => closeModal()}
            type="button"
            className="cancel btn-bottom btn-bottom-cancel"
          >
            {t('common.cancel')}
          </button>
          <button className="accept btn-bottom btn-bottom-create" type="submit" >
            {t('common.yes')}
          </button>
        </div>
      </form>
      {alertModal.visible && <Alerts id="alert-ac-modal" title={alertModal.title} error={alertModal.error} />}
      <Modal isOpen={modalUpdate}  
      style={{
          content: { zIndex: 1100 },  // más alto que el primero
          overlay: { zIndex: 1100 }
        }} 
        ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" alt='' />
          <h1>{t('menu.userExist')}</h1>
          <h1>{t('menu.updateUserConfirm')}</h1>
          <div className="buttons-modal">
            <button
              onClick={() => { 
                setModalUpdate(false)
                closeModal()
              }}
              className="cancel btn-modal-cancel"
            >
              {t('common.cancel')}
            </button>
            <button 
            onClick={() => { update_add_user() }} 
            className="accept">
              {t('common.yes')}
            </button>
          </div>
        </div>
      </Modal>
    </div>


    
  )
}
